import React from 'react';
import { motion } from 'framer-motion';
import { FiArrowUpRight, FiMapPin, FiCheckCircle, FiHome } from 'react-icons/fi';
import './AboutHero.css';
import { useNavigate } from 'react-router-dom';
import useSiteSettings from '../../hooks/useSiteSettings';
import { resolveMedia } from '../../utils/media';

export default function AboutHero() {
  const navigate = useNavigate();
  const { settings } = useSiteSettings();
  return (
    <section className="abh">
      <div className="abh__bg" style={{ backgroundImage:`url(${resolveMedia(settings.aboutHeroImage)})`, backgroundSize:'cover', backgroundPosition:'center' }} />
      <div className="abh__overlay" />
      <div className="container abh__container">
        <div className="abh__grid">
          <motion.div className="abh__left" initial={{ opacity: 0, y: 18 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.55, ease: 'easeOut' }}>
            <div className="abh__pill"><span className="dot" /> Pakistan Real Estate • Projects • High-Rise</div>
            <h1 className="abh__title">{settings.aboutTitle || 'Built on Trust. Delivered with Results.'}</h1>
            <p className="abh__sub">{settings.aboutDescription}</p>
            <div className="abh__ctaRow">
              <button className="abh__btn abh__btn--primary" type="button" onClick={() => navigate('/projects')}>Explore Projects <FiArrowUpRight /></button>
              <button className="abh__btn abh__btn--ghost" type="button" onClick={() => navigate('/contact')}>Contact Us</button>
            </div>
            <div className="abh__chips"><div className="abh__chip"><FiCheckCircle /> Verified Documentation</div><div className="abh__chip"><FiHome /> High-Rise Specialists</div><div className="abh__chip"><FiMapPin /> Multiple Branches</div></div>
          </motion.div>
          <motion.div className="abh__right" initial={{ opacity: 0, y: 18 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.55, ease: 'easeOut', delay: 0.05 }}>
            <div className="abh__card">
              <div className="abh__cardTop"><div className="abh__badge">Trusted Real Estate Brand</div></div>
              <div className="abh__note">“We don’t just sell properties — we help people make confident decisions with clarity and honesty.”</div>
              <div className="abh__signature"><div className="abh__sigName">{settings.siteName || 'RealCity'}</div><div className="abh__sigRole">{settings.siteTagline || 'High-Rise & Investment'}</div></div>
            </div>
            <div className="abh__glow" />
          </motion.div>
        </div>
      </div>
      <div className="abh__fade" />
    </section>
  );
}
